import { render, staticRenderFns } from "./IconSectionCompact.vue?vue&type=template&id=b8572378&"
import script from "./IconSectionCompact.vue?vue&type=script&lang=js&"
export * from "./IconSectionCompact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8572378')) {
      api.createRecord('b8572378', component.options)
    } else {
      api.reload('b8572378', component.options)
    }
    module.hot.accept("./IconSectionCompact.vue?vue&type=template&id=b8572378&", function () {
      api.rerender('b8572378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSectionCompact.vue"
export default component.exports